import { Injectable } from '@angular/core';
import { NewHireAPIMethod } from './../../api-methods/api-methods';
import { UrlConfig } from './../../config/url.config';
import { HttpClientService } from './../http/httpClient.service';
import { HttpHeadersService } from './../http/httpHeaders.service';
import { NewHireDBModel } from './../../model/new-hireDB.model';
import { DeliveryOptions } from './../../model/delivery-options.model';
 
@Injectable({
  providedIn: 'any',
})
export class NewHireService {
  constructor( 
    private _httpClientService: HttpClientService,
    private _httpHeadersService: HttpHeadersService
  ) {}

  getNewHireDetail(groupId: number): any {
    let newHireDetailUrl = `${UrlConfig.baseUrl}${NewHireAPIMethod.GetNewHireDetail}`;
    newHireDetailUrl = newHireDetailUrl.replace(
      '{groupId}',
      groupId.toString()
    );
    return this._httpClientService.get<any>(
      newHireDetailUrl,
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }

  getNewHireDetailById(
    Id: number,
    AllowCompletedRecords: boolean = false
  ): any {
    let newHireDetailUrl = `${UrlConfig.baseUrl}${NewHireAPIMethod.GetNewHireDetailById}`;
    newHireDetailUrl = newHireDetailUrl.replace('{Id}', Id.toString());
    newHireDetailUrl = newHireDetailUrl.replace(
      '{allowCompletedRecords}',
      AllowCompletedRecords.toString()
    );
    return this._httpClientService.get<any>(
      newHireDetailUrl,
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }

  getSupportedBrowsers(): any {
    let rateTableUrl = `${UrlConfig.baseUrl}${NewHireAPIMethod.getSupportedBrowsers}`;
    return this._httpClientService.get<any>(
      rateTableUrl,
      this._httpHeadersService.getRateTableUAHttpOptions()
    );
  }

  saveNewHireDetail(Id: number, data: NewHireDBModel): any {    
    let newHireDetailUrl = `${UrlConfig.baseUrl}${NewHireAPIMethod.PostNewHireDetail}`;
    newHireDetailUrl = newHireDetailUrl.replace('{Id}', Id.toString());
    return this._httpClientService.post(
      newHireDetailUrl,
      data,
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }

  saveMasterCensus(masterCensusDetail: any) {
    let newHireDetailUrl = `${UrlConfig.baseUrl}${NewHireAPIMethod.SaveMasterCensus}`;
    return this._httpClientService.post(
      newHireDetailUrl,
      masterCensusDetail,
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }

  sendPdf(Id: number, data: NewHireDBModel) {
    let newHireDetailUrl = `${UrlConfig.baseUrl}${NewHireAPIMethod.SendPdf}`;
    newHireDetailUrl = newHireDetailUrl.replace('{Id}', Id.toString());
    return this._httpClientService.post(
      newHireDetailUrl,
      data,
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }

  generateEnrollmentWorksheet(Id: number, deliveryModel: DeliveryOptions): any {
    let newHireDetailUrl = `${UrlConfig.baseUrl}${NewHireAPIMethod.GenerateEnrollmentWorksheet}`;
    newHireDetailUrl = newHireDetailUrl.replace('{Id}', Id.toString());
    return this._httpClientService.post(
      newHireDetailUrl,
      deliveryModel,
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }

  getDashboardData(PageNo: number, PageSize: number, searchRequest: any): any {
    let newHireRequestUrl = `${UrlConfig.baseUrl}newhire/search/${PageNo}/${PageSize}`;
    return this._httpClientService.post(
      newHireRequestUrl,
      JSON.stringify(searchRequest),
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }

  getSupportedLanguages(): any {
    const url = `${UrlConfig.baseUrl}${NewHireAPIMethod.getSupportedLanguages}`;
    return this._httpClientService.get<any>(
      url,
      this._httpHeadersService.getNewHireHttpOptions()
    );
  }
}
